import { useEffect, useState, useRef } from "react";

import { inject, observer } from "mobx-react";
import { computed, toJS } from "mobx";

import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";

import DefaultList from "@Common/DefaultList";
import { getStatusTag, handleCopyBuffer } from "@utils";

import moment from "moment";

import "./style.scss";
import { useNavigationHandler } from "@hook";
import TooltipUI from "@UI/TooltipUI";

const CompaniesList = inject("mainStore")(
    observer(({ mainStore }) => {
        const filter = computed(() => mainStore.getMainStore("filter")).get();
        const navigation = useNavigationHandler();
        const [ratesData, setRatesData] = useState(null);

        useEffect(() => {
            getRates();
        }, []);

        const getRates = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=rates", false, "", false, false);
            if (resp && resp.success) {
                setRatesData(resp.data);
            }
        };

        const handleRowClick = (e) => {
            mainStore.setMainStore("detailData", {});
            navigation(e.originalEvent, `/companies/${e.data._id}`);
        };

        const renderTooltipContent = (item) => {
            const isCpc = item?.offerTypeCPC === "cpc";
            let ratesDataFilter = null;

            if (ratesData && item.rateIds) {
                ratesDataFilter = ratesData
                    ?.filter((el) => item.rateIds?.includes(el._id))
                    .reverse()
                    .reduce(
                        (acc, row) => {
                            acc[row.type]?.push(row);
                            return acc;
                        },
                        { cpa: [], accept: [], cpl: [], cpc: [], cpm: [], revenue_share: [] },
                    );
            }

            return (
                <div className="companies__tooltip">
                    <div className="companies__tooltip-item">
                        <h3>Оффер</h3>
                        <span>Название оффера: {item.title}</span>
                        <span>ERID: {item.erid || "-"}</span>
                        <span>Тип оффера: {item.ghostOffer ? "Тестовый" : "Реальный"}</span>
                        <span>Теги: {item.offerOptions ? item.offerOptions.map((opt) => tagsMap[opt]).join(", ") : "-"}</span>
                        <span>Юр.лицо: {item.vendor?.vendorInfo?.fullOpf || "-"}</span>
                    </div>

                    <div className="companies__tooltip-item">
                        <h3>Доступ к предложению</h3>
                        <span>Вопросы: {item?.surveyId ? "есть" : "нет"}</span>
                        <span>Модальное окно: {!isCpc ? "есть" : "нет"}</span>

                        {!isCpc && (
                            <>
                                <span>Валидация номера телефона: {item.inputFields?.some((i) => i.type === "phone" && i.isVerified) ? "есть" : "нет"}</span>
                                {item.workLimitationsDays?.length > 0 ? (
                                    <span>
                                        Дни работы оффера: {weeksArray[item.workLimitationsDays[0] - 1]} - {weeksArray[item.workLimitationsDays[1] - 1]}
                                    </span>
                                ) : null}
                                <span>
                                    Время работы оффера:{" "}
                                    {item.workLimitationsStartTime
                                        ? `c ${moment(item.workLimitationsStartTime).subtract(2, "hours").format("HH:mm")} по ${item.workLimitationsEndTime ? moment(item.workLimitationsEndTime).subtract(2, "hours").format("HH:mm") : ""}`
                                        : "-"}
                                </span>
                            </>
                        )}
                    </div>

                    <div className="companies__tooltip-item">
                        <h3>Конфигурация оффера</h3>
                        <span>Варианты выдачи: {offerType[item.offerType] || "-"}</span>
                        <span>Отправки по API: {item?.apiSendingIds?.length ? "есть" : "нет"}</span>
                    </div>

                    {ratesDataFilter?.cpa?.length || ratesDataFilter?.cpl?.length || ratesDataFilter?.accept.length || ratesDataFilter?.cpc.length || ratesDataFilter?.cpm.length || ratesDataFilter?.revenue_share.length ? (
                        <div className="companies__tooltip-item">
                            <h3>Ставки</h3>
                            {ratesDataFilter.cpa?.length > 0 && <span>CPO: {ratesDataFilter.cpa.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                            {ratesDataFilter.cpl?.length > 0 && <span>CPL: {ratesDataFilter.cpl.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                            {ratesDataFilter.accept?.length > 0 && <span>CPL: {ratesDataFilter.accept.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                            {ratesDataFilter.cpc?.length > 0 && <span>CPL: {ratesDataFilter.cpc.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                            {ratesDataFilter.cpm?.length > 0 && <span>CPL: {ratesDataFilter.cpm.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                            {ratesDataFilter.revenue_share?.length > 0 && <span>CPL: {ratesDataFilter.revenue_share.map((rate) => `${rate.priceWithNds ? rate.priceWithNds + " ₽" : ""} ${rate.comments || ""}`).join(", ")}</span>}
                        </div>
                    ) : (
                        <h3>Ставки -</h3>
                    )}
                </div>
            );
        };

        const columns = [
            {
                field: "_id",
                header: "ID",
                style: { width: "6%", maxWidth: "20px", overflow: "hidden" },
                body: (item) => (
                    <div
                        className="id__copy cursor-pointer"
                        onClick={(e) =>
                            handleCopyBuffer(e, item, "_id", (val) =>
                                mainStore.setMainStore("toast", {
                                    severity: "success",
                                    life: 4000,
                                    summary: "Скопировано",
                                    detail: val,
                                }),
                            )
                        }
                    >
                        <span className="text">ID</span>
                        <i className="pi pi-clone"></i>
                    </div>
                ),
            },
            {
                field: "vendor.name",
                header: "Вендор",
                body: (item) => <span className="list__name">{item?.vendor?.name}</span>,
                style: { maxWidth: "100px", overflow: "hidden" },
                sortable: true,
            },
            {
                field: "technicalName",
                header: "Техническое название",
                body: (item) => <TitleCell item={item} renderTooltipContent={renderTooltipContent} />,
                style: { maxWidth: "100px", overflow: "hidden" },
                sortable: true,
            },
        ];

        if (filter?.headerSelect !== "draft") {
            columns.push(
                {
                    field: "dateStart",
                    header: "Start",
                    body: (item) => <span>{item.dateStart ? moment(item.dateStart).format("DD.MM.YY") : "-"}</span>,
                    style: { width: "10%", maxWidth: "127px", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
                {
                    field: "dateEnd",
                    header: "End",
                    body: (item) => <span>{item.dateEnd ? (moment(item.dateEnd).diff(moment(item.dateStart), "years") > 50 ? "∞" : moment(item.dateEnd).format("DD.MM.YY")) : "-"}</span>,
                    style: { width: "10%", maxWidth: "127px", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
                {
                    field: "dateStopCampaign",
                    header: filter?.headerSelect === "inactive" ? "Pause" : "Launch",
                    body: (item) => <span>{item.dateStopCampaign ? moment(item.dateStopCampaign).format("DD.MM.YY") : "-"}</span>,
                    style: { maxWidth: "50px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                    sortable: true,
                },
            );
        }

        if (filter?.headerSelect === "draft") {
            columns.push({
                field: "dateStartCampaign",
                header: "Created",
                body: (item) => <span>{item.dateStartCampaign ? moment(item.dateStartCampaign).format("DD.MM.YY") : "-"}</span>,
                style: { maxWidth: "30px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                sortable: true,
            });
        }
        if (filter?.filters?.siteIds) {
            columns.push({
                field: "sorts.sort",
                header: "Sort",
                style: { maxWidth: "50px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                sortable: true,
                isEdit: "number",
            });
        }

        columns.push({
            header: "Статус",
            body: (item) => {
                const tag = getStatusTag(item);
                return <Tag severity={tag.type} icon={tag.icon} className={item.__groupKey ? "companies__status-" + item.__groupKey : ""} />;
            },
            style: { width: "1%" },
            sortable: false,
        });

        return (
            <DefaultList
                dataKey="_id"
                apiUrl="/promo/offers"
                keysToGet={[
                    "_id",
                    "vendor.name",
                    "vendor.rateIds",
                    "vendor.vendorInfo.fullOpf",
                    "title",
                    "dateStart",
                    "dateEnd",
                    "active",
                    "archived",
                    "draft",
                    "offerTypeCPC",
                    "offerType",
                    "erid",
                    "ghostOffer",
                    "offerOptions",
                    "surveyId",
                    "inputFields",
                    "workLimitationsDays",
                    "workLimitationsStartTime",
                    "workLimitationsEndTime",
                    "apiSendingIds",
                    "technicalName",
                    "dateStartCampaign",
                    "dateStopCampaign",
                    "rateIds",
                    "sorts",
                ]}
                titleName="Офферы"
                keyFilterSearch="title"
                header={true}
                handleRowClick={handleRowClick}
                columns={columns}
            />
        );
    }),
);

const TitleCell = ({ item, renderTooltipContent }) => {
    const iconRef = useRef(null);

    return (
        <div className="companies__container">
            <TooltipUI position="top" pt={{ text: { style: { backgroundColor: "#424242" } } }} target={iconRef}>
                {renderTooltipContent(item)}
            </TooltipUI>
            <span className="companies__name">{item.technicalName}</span>
            <i ref={iconRef} className="pi pi-info-circle" />
        </div>
    );
};

const offerType = {
    bucket: "корзина с промокодами",
    onepromo: "единный промокод",
    partnerlink: "ссылка",
    leads: "CPL",
};

const weeksArray = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const tagsMap = {
    hit: "«ХИТ»",
    redirect: "«РЕДИРЕКТ»",
};

export default CompaniesList;
